/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import { mapState } from 'vuex';

export default {
  name: 'login-template',

  props: {
    id: {
      type: String,
      default: '',
    },
  },

  components: {
    AwesomeVuetifyForm: () => import('@/plugins/awesome-vuetify-form'),
  },

  data: function () {
    return {
      valid: false,
      alert: false,
      alertMsg: 'There was an error',
      data: {
        username: '',
        password: '',
      },
      nameRules: [
        v => !!v || this.$t('Field is required'),
        v => (v && v.length >= 3) || this.$t('Name must be at least greater than 3 characters'),
      ],
      passwordRules: [
        v => !!v || this.$t('Field is required'),
        v => (v && v.length >= 3) || this.$t('Password must be at least greater than 3 characters'),
      ],
    };
  },

  computed: {
    ...mapState('config', ['configs']),

    loginPlaceholder: function () {
      const id = this.id.toUpperCase();
      return this.configs[`LOGIN_PLACEHOLDER__${id}__LOGIN`] || this.$t('Enter your login');
    },

    passwordPlaceholder: function () {
      const id = this.id.toUpperCase();
      return this.configs[`LOGIN_PLACEHOLDER__${id}__PASSWORD`] || this.$t('Enter your password');
    },
  },

  methods: {
    onSignIn: function () {
      this.$emit('input', this.data);
      this.$emit('onSignIn');
    },

    validate: function () {
      return this.$refs.form.validate();
    },
  },

  watch: {
    data: {
      handler: function (val) {
        this.$emit('input', val);
      },
      deep: true,
    },
  },
};
